var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trialEnterpriseContact"},[_c('p',{staticClass:"title"},[_vm._v("请联系工作人员开通试用账号")]),_vm._m(0),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.copyPhoneNumber}},[_vm._v("复制手机号")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"phoneNumber"},[_c('i',{staticClass:"el-icon-phoneNumber"}),_c('span',[_vm._v("联系电话：010-81720072")])])
}]

export { render, staticRenderFns }